import { MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import React from 'react'
import Select from 'react-select'
import { Card, CardBody, Col, Container, Form, Input, Label, Row } from 'reactstrap'
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"


const columns = [
    {
        label: "Modificado por",
        field: "colaborador_que_modifico_nombre",
        sort: "asc"
    },
    {
        label: "Código",
        field: "articulo_codigo",
        sort: "asc"
    },
    {
        label: "Nombre",
        field: "articulo_nombre",
        sort: "asc"
    },
    {
        label: "Estado",
        field: "estado_nombre",
        sort: "asc"
    },
    {
        label: "Fecha de Registro",
        field: "fecha_registro_str",
        sort: "asc"
    },
    {
        label: "Accion",
        field: "accion",
        sort: "asc"
    },
    {
        label: "Responsable",
        field: "colaborador_responsable_nombre",
        sort: "asc"
    }
];

export default class ReporteHistorialArticulo extends React.Component {

    constructor(props) {
        super(props)

        this.apiRest = new ApiRest(props);

        props = _valid(props, props.props) ? props.props : props;
        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {},
            tabla: { columns: columns, rows: [] },
            colaboradorLista: [],
            estadoLista: [],
            consulta: {
                fecha_inicio: null,
                fecha_fin: null,
                colaborador_que_modifico: null,
                estado: null,
                articulo_nombre: null,
                articulo_codigo: null,
            }
        };
        this.buscar = this.buscar.bind(this);
        this.actualizarValores = this.actualizarValores.bind(this);
        this.borrarFiltros = this.borrarFiltros.bind(this);
    }

    componentDidMount() {
        this.obtenerColaboradores();
        this.obtenerEstados();
    }

    obtenerColaboradores() {
        if (this.apiRest.getRol()) {
            this.apiRest.get('/colaborador').then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ colaboradorLista: resultado.data });
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        } else {
            if (this.apiRest.getLS('idEmpresa')) {
                this.apiRest.getColaborador('/getColaborador/').then(respuesta => {
                    if (respuesta.exitoso) {
                        this.setState({ colaboradorLista: respuesta.data });
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            }
        }
    }

    obtenerEstados() {
        this.apiRest.get('/articuloEstados').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ estadoLista: resultado.data });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    setColaborador = colaborador => {
        this.setState(estadoAnterior => ({
            consulta: { ...estadoAnterior.consulta, ['colaborador_que_modifico']: colaborador }
        }));
    }

    setEstado = estado => {
        this.setState(estadoAnterior => ({
            consulta: { ...estadoAnterior.consulta, ['estado']: estado }
        }));
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            consulta: { ...estadoAnterior.consulta, [name]: value }
        }));
    }

    buscar = async () => {
        const {
            consulta
        } = this.state

        if (this.verificar(consulta)) {
            this.apiRest.post('/reporteHistorialArticulo', consulta).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ tabla: { columns, rows: resultado.data } })
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        } else {
            this.apiRest.getRol() ?
            toastr.error('Seleccione un filtro por favor')
            :  toastr.error('Seleccione Modificado por')
        }
    }

    verificar = (data) => {
        let contador = 0;
        if(this.apiRest.getRol()){
            if (_valid(data.fecha_inicio)) {
                if (_valid(data.fecha_fin)) {
                    contador += 1;
                }
            } else if (_valid(data.colaborador_que_modifico)) {
                contador += 1;
            } else if (_valid(data.estado)) {
                contador += 1;
            } else if (_valid(data.articulo_nombre)) {
                contador += 1;
            } else if (_valid(data.articulo_codigo)) {
                contador += 1;
            }
        }else{
            if(_valid(data.colaborador_que_modifico)){
                contador = 1
            }
        }

        if (contador !== 0) {
            return true;
        } else {
            return false;
        }
    }

    generarReporte = async () => {
        const {
            consulta
        } = this.state

        if (this.validarDatos(consulta)) {
            this.reporteDeDatos(consulta)
        } else {
            toastr.error('No hay datos para exportar a Excel.');
        }
    }

    validarDatos(filtro) {
        for (const property in filtro) {
            if (_valid(filtro[property])) {
                return true;
            }
        }
        return false;
    }

    reporteDeDatos(consulta) {
        const auth = this.apiRest.getLS('authUser');
        if (auth !== null) {
            const headers = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.access },
                responseType: 'blob',
                body: JSON.stringify(consulta)
            }

            fetch(process.env.REACT_APP_API_URL + "/reporteHistorialArticuloExcel", headers)
                .then(resp => {
                    if (resp.status >= 200 && resp.status < 300) {
                        resp.blob().then(blob => {
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement("a");
                            a.style.display = "none";
                            a.href = url;
                            a.download = "Reporte_Historial_Activos.xlsx";
                            document.body.appendChild(a);
                            a.click();
                            window.URL.revokeObjectURL(url);
                        })
                    } else if (resp.status === 401) {
                        this.props.history.push('/Timeout');
                    }
                });
        } else {
            toastr.error('Vaya! No loggeado, por favor intenta nuevamente.');
        }
    }

    borrarFiltros = () => {
        const {
            consulta
        } = this.state

        for (const property in consulta) {
            this.borrarEstado(property)
        }

        this.setState(estadoAnterior => ({
            tabla: {
                ...estadoAnterior.tabla, ['rows']: []
            }
        }));
    }

    borrarEstado(name) {
        this.setState(estadoAnterior => ({
            consulta: {
                ...estadoAnterior.consulta, [name]: ''
            }
        }));
    }

    render() {
        const {
            colaboradorLista,
            estadoLista,
            consulta
        } = this.state;

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Activos" breadcrumbItem={"Historial de Activos"} />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Row>
                                            <Col lg={4}>
                                                <Label htmlFor="colaborador_que_modifico" className="form-label">
                                                    Modificado por
                                                </Label>
                                                <Select
                                                    name="colaborador_que_modifico"
                                                    options={colaboradorLista}
                                                    value={consulta.colaborador_que_modifico}
                                                    onChange={this.setColaborador}
                                                />
                                            </Col>
                                            <Col lg={4}>
                                                <Label htmlFor="fecha_inicio" className="form-label">
                                                    Fecha Inicio
                                                </Label>
                                                <Input
                                                    name="fecha_inicio"
                                                    value={consulta.fecha_inicio}
                                                    onChange={this.actualizarValores}
                                                    type="date"
                                                    className="form-control"
                                                />
                                            </Col>
                                            <Col lg={4}>
                                                <Label htmlFor="fecha_fin" className="form-label">
                                                    Fecha Fin
                                                </Label>
                                                <Input
                                                    name="fecha_fin"
                                                    value={consulta.fecha_fin}
                                                    onChange={this.actualizarValores}
                                                    type="date"
                                                    className="form-control"
                                                />
                                            </Col>
                                        </Row>
                                        <br />
                                        {
                                            this.apiRest.getRol() ?
                                            <Row>
                                                <Col lg={4}>
                                                    <Label htmlFor="articulo" className="form-label">
                                                        Estado
                                                    </Label>
                                                    <Select
                                                        name="estado"
                                                        options={estadoLista}
                                                        value={consulta.estado}
                                                        onChange={this.setEstado}
                                                    />
                                                </Col>
                                                <Col lg={4}>
                                                    <Label htmlFor="articulo_nombre" className="form-label">
                                                        Nombre Activo
                                                    </Label>
                                                    <Input
                                                        name="articulo_nombre"
                                                        value={consulta.articulo_nombre}
                                                        onChange={this.actualizarValores}
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Ingresa el nombre del activo"
                                                    />
                                                </Col>
                                                <Col lg={4}>
                                                    <Label htmlFor="articulo_codigo" className="form-label">
                                                        C&oacute;digo Activo
                                                    </Label>
                                                    <Input
                                                        name="articulo_codigo"
                                                        value={consulta.articulo_codigo}
                                                        onChange={this.actualizarValores}
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Ingresa el código del activo"
                                                    />
                                                </Col>
                                            </Row>
                                            : ''
                                        }
                                        <br />
                                        <Row>
                                            <Col>
                                                <MDBBtn className="waves-effect" color="primary" onClick={this.buscar}>
                                                    <MDBIcon icon="fas fa-search" />{' '}
                                                    Buscar
                                                </MDBBtn>
                                                {' '}
                                                <MDBBtn color="success" onClick={this.generarReporte}>
                                                    <MDBIcon icon="fas fa-book" />{' '}
                                                    Generar Reporte en Excel
                                                </MDBBtn>
                                                {' '}
                                                <MDBBtn className="waves-effect" color="warning" onClick={this.borrarFiltros}>
                                                    <MDBIcon icon="fas fa-trash-alt" />{' '}
                                                    Borrar Filtros
                                                </MDBBtn>
                                            </Col>
                                        </Row>
                                        <br />
                                        <div className="p-4 border-top">
                                            <Form>
                                                <Row>
                                                    <Col lg={12}>
                                                        <div className="table-responsive">
                                                            <MDBDataTable hover searchLabel="Buscar.." paginationLabel={["Anterior", "Siguiente"]} noRecordsFoundLabel="No hay datos." infoLabel={["Mostrando desde ", "hasta", " | Entradas totales: ", ""]} entriesLabel="Mostrando entradas" data={this.state.tabla} />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </div>
                                        <br />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}